module.exports = __webpack_public_path__ + "static/media/carrito.7c509755.svg";